import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const TextArea = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    isField,
    error,
    ...extraProps
  } = props;
  return /*#__PURE__*/_jsx("textarea", {
    className: "form-control",
    ...extraProps,
    ref: ref
  });
});
TextArea.displayName = 'TextArea';
export default TextArea;